module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADCSURBVGhD7dMtCkJBGIXhUTG5A4PV4CoEwY3YrW5CsJjEpJuymN2AYPHn/cBwkbnm813OAy8Dk+aEKWat+t8zrR5t6UEXmlI6MeJI70YnSqU2IjpQGvEfaiOuNKYU/o2YUAoeocIjVHiECo9Q4REqPEKFR6joxIiwo/QjRvSk5ogbpRoRBhQPbw550YrSmdOdOjFmQR6jyGNUeYwqj1HlMao8RpXHqPIYVW1jlpRObcyZUvods6G0ZrSnNQ3jwkxCKR+8BekpyRbCfQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/left-arrow-filled-50-black.png
// module id = 255
// module chunks = 2 30